import React from 'react';
import './style.css';

export interface IModalDialogProps {
  openModal: boolean;
  title: string;
  content: any;
  footer?: any;
  size?: 'small' | 'medium' | 'large' | 'extra-large';
  onClose?: any;
}

const ModalDialog: React.FunctionComponent<IModalDialogProps> = ({ openModal = false, title, content, footer, size = 'small', onClose }) => {
  return !openModal ? null : (
    <>
      <div
        className="modal"
        onClick={(e) => {
          if ((e.target as HTMLDivElement).className === 'modal') {
            onClose();
          }
        }}
      >
        <div className={`modal-dialog ${size}`}>
          <div className="header">
            <div className="title">{title}</div>
            <button type="button" onClick={onClose}>
              &times;
            </button>
          </div>
          <div className="body">
            <div className="content">{content}</div>
          </div>
          {footer == null ? null : (
            <>
              <div className="footer">{footer}</div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ModalDialog;
